import React, {useState} from 'react';
import copy from '../../assets/images/copy-white.svg';
import {useNavigate} from "react-router-dom";
import toastOptions from "../../data/ToastOptions";
import {useShallowPickSelector} from "../../redux";
import {toast} from "react-toastify";
// import Table from "../../components/affiliate/table";
import Modal from "../../components/modal";
import SharePost from "../../components/affiliate/SharePost";
import {copyToClipboard} from "../../components/GlobalFunctions";

let timeout;

const Affiliate = () => {
    let navigate = useNavigate();
    const {tgUser} = useShallowPickSelector('user', ['tgUser'])
    const {mainData} = useShallowPickSelector('app', ['mainData'])
    const [show, setShow] = useState(false);

    const goToPanel = () => {
        navigate('/affiliate/panel')
    }

    const copyFn = (linkValue) => {
        copyToClipboard(linkValue)
        // navigator.clipboard.writeText(linkValue)
        // toast.success('Referral Link Copied.', {...toastOptions, toastId: 20});
    }

    const closeModal = () => {
        const modalBackdrop = document.querySelector('.modal-backdrop');
        const modal = document.querySelector('.modal');
        modalBackdrop.style.animation = 'fadeOut 0.3s forwards';
        modal.style.animation = 'slideUp 0.3s forwards';

        timeout = setTimeout(() => {
            setShow(false);
        }, 300);
    }

    return (
        <div className="container">
            <div className="affiliate-container minHUnset relative">
                <div className="mt60">
                    <p className="text-white text-center font-bold fs18">Partner with Jace</p>
                    <p className="text-white text-center fs16">Share JetApp or become an affiliate and team up with friends to earn Commission Points (CPs).</p>
                </div>
                <div className="column center affiliate-middleBoxContainer my40">
                    <p className="text-white fs18">Your Referral Link</p>
                    <div className="w100 start relative mt10">
                        <div className="affiliate-referralLinkCodeContainer">
                            <p className="text-white fs14 lineNumber1">{mainData?.tapp_ref_link}</p>
                            <button type="button" className="affiliate-copyBtn pointer" onClick={() => copyFn(mainData?.tapp_ref_link)}>
                                <img alt="Jace Referral" src={copy} className="affiliate-copyImg" />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="column center">
                    <button type="button" className="button m0" onClick={() => setShow(true)}>
                        <span className="text-white">Invite Friends</span>
                    </button>
                    <button type="button" className="button m0" onClick={goToPanel}>
                        <span className="text-white">Affiliate Panel</span>
                    </button>
                </div>
            </div>
            {/* <Table /> */}
            <Modal isOpen={show} onClose={closeModal} containerClass="affiliate-mainContainer">
                <SharePost link={mainData?.tapp_ref_link} closeModal={closeModal} />
            </Modal>
            <div className="h50"></div>
        </div>
    );
}

export default Affiliate;
